import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'main', controller: 'Activity') => ({
	Create: new PostMethod<any, any>({
		service,
		controller,
		method: 'Create'
	}),
	CreateDm: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateDm'
	}),
	CreateWf: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateWf'
	}),
	CreateForm: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateForm'
	}),
	Update: new PostMethod<any, any>({
		service,
		controller,
		method: 'Update'
	}),
	Delete: new PostMethod<any, any>({
		service,
		controller,
		method: 'Delete'
	}),
	Reply: new PostMethod<any, any>({
		service,
		controller,
		method: 'Reply'
	}),
	GetAll: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetAll'
	}),
	GetAllByRelationDm: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetAllByRelationDm'
	}),
	GetAllByRelationWf: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetAllByRelationWf'
	}),
	GetAllByRelationForm: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetAllByRelationForm'
	}),
	Get: new PostMethod<any, any>({
		service,
		controller,
		method: 'Get'
	}),
	GetReplyActivities: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetReplyActivities'
	}),
	SetReaction: new PostMethod<any, any>({
		service,
		controller,
		method: 'SetReaction'
	}),
	UnsetReaction: new PostMethod<any, any>({
		service,
		controller,
		method: 'UnsetReaction'
	}),
	SearchUser: new PostMethod<any, any>({
		service,
		controller,
		method: 'SearchUser'
	}),
	SearchDm: new PostMethod<any, any>({
		service,
		controller,
		method: 'SearchDm'
	}),
	SearchWf: new PostMethod<any, any>({
		service,
		controller,
		method: 'SearchWf'
	})
});

export { getMethods };
